<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>{{ modalTitle }}</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <p class="text-danger text-center" v-if="hasError">{{ errorMessage }}</p>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input container-class="mb-3" type="select" label="Opérateur" :options="operators"
                     v-model="operator" :state="operatorState">
              <template slot="first">
                <option :value="null">-- Sélectionnez un opérateur --</option>
              </template>
              Veuillez sélectionner un opérateur
            </c-input>
            <c-input container-class="mb-3" label="Nom de la gateway" placeholder="Ex: CAMO Gateway"
                     v-model="name" :state="nameState">
              Veuillez saisir un nom
            </c-input>
            <c-input container-class="mb-3" label="Slug" placeholder="Ex: MCP" v-model="slug" :state="slugState">
              Veuillez saisir un slug
            </c-input>
            <c-input container-class="mb-3" label="Adresses IP autorisées (séparateur: , )" v-model="authorized_ip"
                     :state="authorized_ipState">
              Veuillez saisir * ou les adresses IP séparées par des virgules
            </c-input>
            <c-input type="textarea" container-class="mb-3" label="Description" placeholder="Entrez une description..."
                     v-model="description"/>
          </d-col>
          <d-col class="ml-2">
            <b-form-group>
              <label class="font-weight-bold mb-0">Clé publique</label>
              <d-input-group>
                <d-input-group-addon class="flex-fill" prepend>
                  <c-input class="flex-fill" :value="public_key" disabled/>
                </d-input-group-addon>
                <d-input-group-addon append>
                  <b-button variant="primary" @click="onCopyPublicKey" :disabled="!public_key">
                    <i class="fa fa-copy mr-1"></i> Copier
                  </b-button>
                </d-input-group-addon>
              </d-input-group>
            </b-form-group>
            <b-form-group>
              <label class="font-weight-bold mb-0">Clé privée</label>
              <d-input-group>
                <d-input-group-addon class="flex-fill" prepend>
                  <c-input class="flex-fill" :value="private_key" disabled/>
                </d-input-group-addon>
                <d-input-group-addon append>
                  <b-button variant="primary" @click="onCopyPrivateKey" :disabled="!private_key">
                    <i class="fa fa-copy mr-1"></i> Copier
                  </b-button>
                </d-input-group-addon>
              </d-input-group>
            </b-form-group>
            <c-input type="datetime" container-class="mb-3" label="Créé le" :value="created_at" disabled/>
            <c-input type="datetime" container-class="mb-3" label="Dernière modification"
                     :value="updated_at" disabled/>
            <c-input type="datetime" container-class="mb-3" label="Dernière activité"
                     :value="last_request_at" disabled/>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-header class="px-4">
        <d-input-group class="justify-content-center">
          <d-button class="inline-btn" @click="modalVisible = true">
            <i class="fa fa-plus mr-1"></i> Ajouter une gateway
          </d-button>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="data" :fields="fields" :actions="actions" :per-page="10">
          <p class="text-center" slot="empty">Aucune gateway trouvée.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import { Api, asset, Regex, Toast } from "../../helpers/index"
import Input from "@/components/Input.vue"

export default {
  components: { Input },
  title: "Paramètres des gateways",
  data() {
    return {
      fetchingData: false,
      data: [],
      operators: [],

      //table header
      fields: [
        {
          key: "logo",
          label: "Opérateur",
          sortable: true,
        },
        {
          key: "name",
          label: "Nom",
          sortable: true,
        },
        {
          key: "slug",
          label: "Slug",
          sortable: true,
        },
        {
          key: "public_key",
          label: "Clé publique",
          sortable: true,
        },
        {
          key: "last_request_at_pretty",
          label: "Dernière activité",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
        },
      ],

      actions: [
        {
          type: "white",
          icon: "fa fa-cog",
          title: "Paramètres de la gateway",
          handler: this.onItemSelect,
        },
        {
          type: "outline-danger",
          icon: "fa fa-times",
          title: "Supprimer la gateway",
          handler: this.onItemRemove,
        },
      ],

      modalVisible: false,

      selectedItem: null,

      name: "",
      slug: "",
      description: "",
      authorized_ip: "",
      operator: null,

      submitted: false,
      fetchingFormSubmit: false,
    }
  },
  computed: {
    itemSelected() {
      return !!this.selectedItem
    },
    modalTitle() {
      return this.itemSelected ? "Paramétrage d'une gateway" : "Ajout d'une gateway"
    },
    public_key() {
      return this.itemSelected ? this.selectedItem.public_key : ""
    },
    private_key() {
      return this.itemSelected ? this.selectedItem.private_key : ""
    },
    created_at() {
      return this.itemSelected ? this.selectedItem.created_at : ""
    },
    updated_at() {
      return this.itemSelected ? this.selectedItem.updated_at : ""
    },
    last_request_at() {
      return this.itemSelected ? this.selectedItem.last_request_at : ""
    },
    nameState() {
      return !this.submitted || this.name.trim().length > 0
    },
    slugState() {
      return !this.submitted || this.slug.trim().length > 0
    },
    descriptionState() {
      return true
    },
    authorized_ipState() {
      return !this.submitted || this.authorized_ip === "*" || Regex.isValidIpList(this.authorized_ip)
    },
    operatorState() {
      return !this.submitted || this.operator != null
    },
  },
  created() {
    this.fetchingData = true

    Api.get("/operator/list")
      .then(res => {
        this.operators = res.data.operators.map(this.mapOperator)
      })
      .catch(err => this.error = err)
      .then(() => null)

    Api.get("/operator_gateway/list")
      .then(res => {
        this.data = res.data.gateways.map(this.mapItem)
      })
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapOperator(operator) {
      return {
        text: operator.name,
        value: operator.id,
      }
    },
    mapItem(item) {
      return {
        ...item,
        logo: asset(item.operator.logo),
        last_request_at_pretty: item.last_request_at ? item.last_request_at.replace(" ", "\n") : "---",
      }
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.modalVisible = true
      this.name = item.name
      this.slug = item.slug
      this.description = item.description
      this.authorized_ip = item.authorized_ip || ""
      this.operator = item.operator.id
    },
    clearFields() {
      this.name = ""
      this.slug = ""
      this.description = ""
      this.authorized_ip = ""
      this.operator = null
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.error = null
      this.selectedItem = null
      this.clearFields()
    },
    isFormValid() {
      return this.nameState && this.slugState
        && this.descriptionState && this.authorized_ipState
        && this.operatorState
    },
    onFormSubmit() {
      this.submitted = true

      if (!this.isFormValid()) return

      const route = this.itemSelected ? "/operator_gateway/update" : "/operator_gateway/create"
      const extraData = this.itemSelected ? { gateway_id: this.selectedItem.id } : {}

      this.fetchingFormSubmit = true
      Api.postFormData(route, {
        name: this.name,
        slug: this.slug,
        description: this.description,
        authorized_ip: this.authorized_ip,
        operator_id: this.operator,
        ...extraData,
      })
        .then(res => {
          const gateway = this.mapItem(res.data.gateway)
          const operation = this.itemSelected ? "mise à jour" : "créée"

          if (this.itemSelected) {
            this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, gateway)
            this.onModalClose()
          } else {
            this.data.push(gateway)
            this.onItemSelect(gateway)
          }

          Toast.success(`La gateway "${gateway.name}" a été ${operation} avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    onItemRemove(item) {
      const ans = prompt(`Veuillez saisir SUPPRIMER pour supprimer la gateway "${item.name}".`)
      if (ans !== "SUPPRIMER") return

      Toast.loading("Suppression de la gateway...")
      Api.postFormData("/operator_gateway/delete", {
        gateway_id: item.id,
      })
        .then(() => {
          this.data = this.data.filter(_item => _item.id !== item.id)
          Toast.success(`La gateway "${item.name}" a été supprimée avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => Toast.loadingToast.goAway())
    },
    onCopyPublicKey() {
      navigator.clipboard.writeText(this.public_key)
      Toast.success("Clé publique copiée avec succès")
    },
    onCopyPrivateKey() {
      navigator.clipboard.writeText(this.private_key)
      Toast.success("Clé privée copiée avec succès")
    },
  },
}
</script>

<style scoped>
.table td {
  white-space: normal !important;
  padding: 0 1rem !important;
}
</style>
